import { NotificationManager } from 'react-notifications';
import axios from 'axios';

import { IMerchantAccount, ISiteSearch } from './types';

export const fetchMerchantAccountByIdRequest = async (id: string): Promise<IMerchantAccount | null> => {
  try {
    const res = await axios.get(`api/v1/payment/merchant-accounts/${id}`);

    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't fetch account ${id}`);
    return null;
  }
};

export const updateProvidersMerchantRequest = async (
  vals: Partial<IMerchantAccount>,
  merchantType: string,
): Promise<IMerchantAccount | null> => {
  try {
    const data = { ...vals };
    delete data.id;
    delete data.identity;
    const res = await axios.post(`/api/v1/${merchantType}/merchant-accounts/${vals.id}/settings`, data);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't update provider`);
    return null;
  }
};

export const fetchSiteSearchRequest = async (): Promise<ISiteSearch[] | []> => {
  try {
    const res = await axios.get(`api/v1/search-filter/site`);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't fetch sites`);
    return [];
  }
};
